export default "query getRegionTree($id: String) {\n  getRegionTree(id: $id) {\n\t\t_ALL_\n\t}\n}";